import './UserProfile.scss';
import UserProfileProps from './UserProfileProps';
import logo_background from '../../../../assets/images/logo-background.svg';
import avatar from '../../../../assets/images/avatar.png'
import { useDispatch } from 'react-redux';
import { togglePersonalInfoPopup } from '../../../../store/actions/mainActions';
import { useSelector } from 'react-redux';
import {Fragment, useEffect, useState} from 'react';
import { environment } from "../../../../environment";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'



export const UserProfileImageTrigger = (props: { me: any , className : string }) => {

    const { me , className } = props;
    const dispatch = useDispatch()

    const showPersonalInfoPopup = () => {
        dispatch(togglePersonalInfoPopup(true))
    }

    return me ? (
        <div className={className} onClick={showPersonalInfoPopup}>
            {me.image ?
                <img className="photo" src={me.image ? me.image : null} alt="user"  /> :
                <div className="photo userInitials"> {me.firstName.charAt(0).toUpperCase() + me.lastName.charAt(0).toUpperCase()} </div>
            }
        </div>

    ) : null
}

const UserProfile = (props: UserProfileProps) => {

    const { me } = useSelector((state: any) => state.auth)
    const [state, setState] = useState<any>(null)

    const styles = {
        skeleton: {
            width: 700,
            height: 10
        }
    };

    const skeletonObj = <SkeletonTheme >
        <div className="row flex-wrap overflow-h ">
            <div className="col-12 d-flex justify-content-left mt-4">
                <Skeleton circle={true} height={150} width={150} />
            </div>
            {Array.from(Array(5).keys()).map((e, i) => {
                return <Fragment key={i}>
                    <div className="col-12 d-flex justify-content-center mt-1">
                        <p className="m-0 p-0"><Skeleton style={styles.skeleton} /></p>
                    </div>
                </Fragment>
            })}
        </div>
    </SkeletonTheme>


    useEffect(() => {
        setState({ me: { ...me } })
    }, [me, me?.connections])

    return state && state.me ? (
        <div className="user-profile px-3 pb-3">


            {!state.me.firstName ? skeletonObj :
                <div className="top">
                    <img className="logo-background" src={logo_background} alt="logo-background"/>
                    <UserProfileImageTrigger me={me} className=''/>
                </div>
            }
            <div className="body">
                <h2 className="name">{!state.me.firstName ? null : state.me.firstName + ' ' + state.me.lastName }</h2>
                {state.me.title ? 
                <div className="title">{state.me.title}</div>
                : null}
                
                {state.me.role === 'Administrator' ? 
                    <div className="title text-success">
                        <div className="">Version Date: {environment.reactAppDate ? environment.reactAppDate : ""}</div>
                        <div className="">Agent: {navigator.userAgent.split('(')[0]}</div>
                    </div>
                : null }
                {/*{state.me.connections && Array.isArray(state.me.connections) ?*/}
                {/*<div className="details-row">*/}

                {/*    <div className="details-wrap">*/}
                {/*        <div className="details-text">Connections</div>*/}
                {/*       <div className="details-value">{state.me.connections && Array.isArray(state.me.connections) ? state.me.connections.length : 0}</div>*/}
                {/*    </div>*/}

                {/*    <div className="details-wrap">*/}
                {/*        <div className="details-text">Communities</div>*/}
                {/*        <div className="details-value">{state.me.userCommunities && Array.isArray(state.me.userCommunities) ? state.me.userCommunities.length : 0}</div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*: null*/}
                {/*}*/}
            </div>
        </div>
    ) : null
}

export default UserProfile;

